<template>
  <!--转学申请-->
  <div class="html">
    <div class="body">
      <div id="header">
        <div class="box1">
          <div class="box2">
            <p class="Chinese">长春新区招生入学管理平台</p>
            <p class="English">
              CHANG CHUN XIN QU ZHAO SHENG RU XUE GUAN LI PING TAI
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="content">
      <div class="box3">
        <ul class="ul1">
          <li>
            <a @click="onjump()"><span>首页</span></a>
          </li>
          <li>
            <a @click="jump('distRecruitStudents')"><span>招生政策</span></a>
          </li>
          <li>
            <a @click="jump('distDegree')"><span>学位占用查询</span></a>
          </li>
          <li>
            <a href="http://www.ccxq.gov.cn/ztzl/xqcx"><span>学区查询</span></a>
          </li>
          <li id="li" @mouseleave="show = false" @mousemove="show = true">
            <span>学位预警</span>
            <ul id="ul2" :class="show == false ? '' : 'dis'">
              <a @click="jump('distWarningInfo')"><li>学位预警信息</li></a>
              <a @click="jump('waringMap')"><li>预警地图</li></a>
            </ul>
          </li>
          <li>
            <a @click="jump('distTransfer')" class="special"
              ><span>转学申请</span></a
            >
          </li>
          <li>
            <a @click="jump('distGuide')"><span>办事指南</span></a>
          </li>
        </ul>
      </div>

      <div class="notice">
        <!--箭头框-->
        <div class="border">转学申请功能暂未开通</div>
        <a @click="jump('distTransfer')"><span>确定</span></a>
      </div>
    </div>

    <!--底部-->
    <div class="interlayer"></div>
    <foot></foot>
  </div>
</template>
<script>
import { districts, action, getInfoListByOrgId } from "@/modules/district/api";
import { mapState } from "./state";
import foot from "@/components/foot.vue";
export default {
  name: "degree",
  data() {
    return {
      newYear: new Date().getFullYear(),
      districts: [],
      action: [],
      trends: "",
      arr: [],
      showcheckeddetailelement: false,
      show: false,
    };
  },
  components: {
    foot,
  },
  computed: {
    ...mapState(["districtName", "currentPage"]),

    name() {
      return this.$site.getName();
    },

    orgId() {
      return this.$site.getOrg();
    },
  },

  created() {
    this.loadBaseData();
  },
  methods: {
    async loadBaseData() {
      await districts().then((res) => {
        if (res.code == "0") {
          this.districts = res.data;
          for (let i = 0; i < this.districts.length; i++) {
            let item = this.districts[i];
            if (item.name != this.name) {
              this.arr.push(item);
            }
          }
        }
      });

      let res = await action({ orgId: this.orgId, templateId: 1 });
      this.action = res.data;
      // res = await infoList({params: 4, city: 2201, currentPage: this.currentPage})
      // this.trends = res.data.list[0].content
      res = await getInfoListByOrgId({
        params: 4,
        orgId: this.orgId,
        currentPage: this.currentPage,
      });
      this.trends = res.data.list[0].content; //lv
    },

    onjump() {
      window.location.href = "/#/";
    },

    jump(item) {
      if (item == "distSchDistrict") {
        if (this.orgId == 220104) {
          window.location.href =
            "http://www.cczhcy.com/payment/education-district";
        } else if (this.orgId == 220177) {
          window.location.href = "http://ccxq.gov.cn/xueqvchaxun.aspx";
        } else {
          this.$router.push(item);
        }
      } else {
        this.$router.push(item);
      }
    },

    transname(orgId, name) {
      this.$site.setOrg(orgId);
      this.$site.setName(name);
      //this.$router.go(0)
      this.$router.push("distDegree");
    },
    enroll() {
      alert("敬请期待...");
    },
  },
};
</script>
<style>
* {
  margin: 0;
  padding: 0;
  list-style: none;
  text-decoration: none;
}
.html {
  width: 100%;
  height: auto;
  min-height: 100%;
  position: relative;
  overflow-x: hidden;
  overflow: hidden;
}

.body {
  width: 100%;
  height: auto;
  position: relative;
}
#header {
  width: 100%;
  height: 239px;
  background: url("../../../assets/eduDefault/bg.png") no-repeat;
  background-size: cover;
  position: relative;
}
.box1 {
  width: 668.16px;
  height: 84.96px;
  position: absolute;
  top: 60px;
  cursor: pointer;
}
.box2 {
  width: 583.2px;
  height: auto;
  position: absolute;
  right: 0;
  top: 0;
}
.Chinese {
  font-family: PingFangSC-Semibold;
  font-size: 43.2px;
  color: #3d3d3d;
  letter-spacing: 2px;
  font-weight: bold;
}
.English {
  font-family: PingFang-SC-Semibold;
  font-size: 14px;
  color: #494949;
  letter-spacing: 2px;
  line-height: 36px;
}

.box3 {
  width: 100%;
  height: auto;
  background: #ffffff;
  box-shadow: 0 9px 10px 5px rgba(224, 224, 224, 0.5);
}
.box3 .ul1 {
  width: 1148px;
  height: 54px;
  margin: 0 auto;
}

.box3 .ul1 li {
  width: 164px;
  height: 54px;
  line-height: 54px;
  float: left;
  text-align: center;
  cursor: pointer;
  font-size: 15.6px;
  font-family: PingFangSC-Regular;
  color: #000000;
  letter-spacing: -0.66px;
}
.box3 .ul1 li a {
  color: #000;
  display: block;
}
.box3 .ul1 li:hover a {
  color: #fff;
}

.box3 .ul1 li:hover {
  background: #abe000;
  color: #fff;
}

.box3 .ul1 .special {
  background: #abe000;
  color: #fff;
}

#ul2 {
  display: none;
  z-index: 999;
}
#ul2 a li {
  background: #fff;
  box-shadow: 0 9px 10px 5px rgba(224, 224, 224, 0.5);
}
#ul2 a:hover li {
  background: #abe000;
  color: #fff;
}
.notice {
  width: 1130px;
  height: auto;
  margin: 30px auto;
  padding-top: 20px;
  padding-bottom: 30px;
}

.notice .border {
  width: 350px;
  height: 150px;
  border: 8px solid #abe000;
  margin: 50px auto;
  text-align: center;
  font-size: 26px;
  line-height: 150px;
}
.notice span {
  display: block;
  width: 80px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  color: #fff;
  font-size: 20px;
  background: #abe000;
  margin: 0 auto;
  border-radius: 10px;
  cursor: pointer;
}

/*底部*/
.interlayer {
  width: 100%;
  height: 10px;
  background: #abe000;
}

#footer {
  width: 100%;
  height: auto;
  background-image: linear-gradient(180deg, #2a76e6 0%, #5ab6ff 100%);
}

.link .ul4 a {
  color: #fff;
  font-size: 16px;
  text-decoration: none;
  line-height: 42px;
}

#footer .footer-bottom {
  width: 100%;
  height: 108.8px;
  background: #fff;
}

#footer .footer-bottom .box7 {
  color: #5f6464;
  font-size: 16px;
  position: relative;
  top: 24.4px;
  letter-spacing: 0.5px;
}

#footer .footer-bottom .box7 p {
  line-height: 30px;
  text-align: center;
}
#footer .footer-bottom .box7 p:nth-child(3) {
  margin-left: -9px;
}

#footer .footer-bottom .box7 img {
  width: 20px;
  height: 20px;
  position: relative;
  left: 0px;
  top: 3px;
  margin-right: 5px;
}

.dis {
  display: block !important;
}
.none {
  display: none !important;
}
</style>
